import * as React from "react";
// Components
import { TextField as FabricTextField, useTheme } from "@fluentui/react";
// Styles
import { getTextFieldStyleFunction } from "./TextField.styles";
// Utilities
import { css } from "@fluentui/utilities/lib/css";
import { TextFieldType } from "./TextField.styles";
// Re-export for convenience
export { TextFieldType };
/**
 * TextField control that customizes the fabric control to our own purposes
 */ export const TextField = (props)=>{
    const isBucketStyle = props.styleType === TextFieldType.Bucket;
    const isDialogStyle = props.styleType === TextFieldType.Dialog;
    const isTextStyle = props.styleType === TextFieldType.Text;
    const isTitleStyle = props.styleType === TextFieldType.Title;
    const isTitleUnderlinedStyle = props.styleType === TextFieldType.TitleUnderlined;
    const className = css(props.className, {
        isBucketStyle
    }, {
        isDialogStyle
    }, {
        isTextStyle
    }, {
        isTitleStyle
    }, {
        isTitleUnderlinedStyle
    });
    const theme = useTheme();
    const fabricTextFieldProps = {
        ...props,
        className,
        styles: getTextFieldStyleFunction(theme, props.styleType, props.styles),
        borderless: isBucketStyle || isDialogStyle || isTextStyle || isTitleUnderlinedStyle || !isTitleStyle
    };
    return /*#__PURE__*/ React.createElement(FabricTextField, fabricTextFieldProps);
};
